import { history, store } from '../../redux/store'
import { setProductName } from '../../redux/actions/product'
import { POST } from '../API'
const { dispatch } = store

const SetProduct = (productName) => {
  localStorage.setItem('product', productName)
  dispatch(setProductName(productName))

  if (productName === 'tank') history.push('/Tank')
  else history.push('/cold')
}

const ProducAuth = async (tenantId) => {
  const body = { tenantId }
  const response = await POST('/spectro/users/productlogin', '', body.tenantId)
  return response
}

export { SetProduct, ProducAuth }
